import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { PadContainer, icons } from 'smartsuite-ui';
import useLink from '../../../../shared/hooks/linkHooks';

function renderValue(indicatorColor, openLinksInNewTab, uri, value) {
    if (uri) {
        return (
            <a
                href={uri}
                className="number-with-indicator__value"
                rel="noreferrer"
                target={openLinksInNewTab ? '_blank' : ''}
            >
                {value}
            </a>
        );
    }

    return (
        <span
            className="number-with-indicator__value"
            style={{
                color: indicatorColor,
            }}
        >
            {value}
        </span>
    );
}

function NumberWithIndicator({
    linkConfig,
    metricRequest,
    indicatorColor,
    openLinksInNewTab,
    threshold,
    value,
    footnoteLabel,
}) {
    const linkUri = useLink(linkConfig, metricRequest);

    return (
        <>
            <div className="number-with-indicator">
                {renderValue(indicatorColor, openLinksInNewTab, linkUri, value)}
                <PadContainer cssClassModifiers={['pad-medium']} />
                <div className="number-with-indicator__threshold">
                    <span className={icons.target} />
                    <PadContainer cssClassModifiers={['pad-small']} />
                    <span>{threshold}</span>
                </div>
            </div>
            <div className="number-with-indicator__footnote-label">
                {footnoteLabel}
            </div>
        </>
    );
}

NumberWithIndicator.propTypes = {
    indicatorColor: PropTypes.string.isRequired,
    linkConfig: PropTypes.instanceOf(Object),
    metricRequest: PropTypes.instanceOf(Object).isRequired,
    openLinksInNewTab: PropTypes.bool.isRequired,
    threshold: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    footnoteLabel: PropTypes.string,
};

export default React.memo(
    NumberWithIndicator,
    (prevProps, nextProps) =>
        _.isEqual(prevProps.value, nextProps.value) &&
        _.isEqual(prevProps.threshold, nextProps.threshold)
);
